export class ShoelaceLoader {
    private intervalDuration: number;

    constructor(intervalDuration: number = 100) {
        this.intervalDuration = intervalDuration; // Intervall in Millisekunden
    }

    public async waitForSLReady(): Promise<void> {
        await new Promise<void>((resolve) => {
            const interval = setInterval(() => {
                customElements.whenDefined('sl-icon').then(() => {
                    document.body.classList.add('sl-ready');
                    clearInterval(interval);
                    resolve();
                });
            }, this.intervalDuration);
        });
    }
}
